import { useEffect, useState } from "react";

/**
 * The tenant's logo, or a tile with its initial when it has no logo or the
 * image cannot be loaded. Pass the size and corner classes in `className`.
 */
export default function TenantLogo({ tenant, className = "h-9 w-9 rounded-lg" }) {
  const url = tenant?.branding?.logo_url;
  const name = tenant?.branding?.app_name || tenant?.business_name || "A";
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [url]);

  if (url && !failed) {
    return <img src={url} alt="" onError={() => setFailed(true)} className={`${className} object-cover flex-shrink-0`} />;
  }
  return (
    <div className={`${className} brand-primary flex items-center justify-center font-bold flex-shrink-0`} aria-hidden="true">
      {name[0]}
    </div>
  );
}
